import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

// 引入插件vue-router
import VueRouter from 'vue-router'
// 使用引入的插件
Vue.use(VueRouter) // vue2 此语句必须要

import { Settings as LuxonSettings } from 'luxon'
require('./styles/edsCSS.css')
LuxonSettings.defaultLocale = 'zh-cn'
Vue.config.productionTip = false
import Photoswipe from 'vue-pswipe'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import '@/styles/style.scss' // global css
import router from './router'
import store from './store/'
import i18n from './lang/index' // 导入 i18n 实例


Vue.use(MintUI)
Vue.component('datetime', Datetime)

Vue.use(Photoswipe, {
  fullscreenEl: false,
  errorMsg: '<div class="pswp__error-msg">图片加载失败，可能被后台删除</div>'

})

// 增加cordova文件
if (window.location.protocol === 'file:') {
  let cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

new Vue({
  router, // 挂载：路由管理 实例  Vue 会自动将 router 注入到每个子组件的 this.$router 即：挂载后，this.$router 和 router 指向同一个 Vue Router 实例
  store, // 挂载：状态管理(数据仓库) 实例
  i18n, // 挂载 i18n 实例
  render: h => h(App)  // 指定根组件
}).$mount('#app')

